import styled from "styled-components";

import { T_PLAIN_big } from "../../../../global.style";

export const AnnualTaxSettlementOverviewTable = styled.div`
    ${T_PLAIN_big};
    display: grid;
    grid-template-columns: 17px minmax(200px, 620px) 120px;
    column-gap: 32px;
    row-gap: 8px;
    width: 100%;
    
    div:nth-child(3n + 1) {
        text-align: right;
    }
    
    div:nth-child(3n + 3) {
        text-align: right;
    }
`;

export const AnnualTaxSettlementOverviewCell = styled.div<{
    $isSubRow?: boolean
    $isBold?: boolean;
}>`
    font-weight: ${({ $isBold }) => $isBold ? "bold" : "normal"};
    padding-left: ${({ $isSubRow }) => $isSubRow ? "12px" : "0"};
`;